<template>  
    <div class="main-wrapper">
        <Header></Header>
            <div class="content">
                <div>
                    <b-modal id="modal_business_card" centered hide-footer>
                        <Slider/>
                    </b-modal>
                </div>
                <transition  name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </div>
        <Footer></Footer>
    </div>
</template>

<script>

import Footer from './Footer';
import Header from './Header';
import Slider from '../../components/Slider.vue';

export default {
    components: {
    Header,
    Footer,
    Slider
},  mounted() {
    var cardHolderInfo = this.$auth.getCardInfo();
    if(cardHolderInfo.CartType === 'Business'){
        this.$bvModal.show("modal_business_card");
    }

  }
}
</script>

<style>
@import 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&amp;subset=cyrillic,cyrillic-ext';

.main-wrapper{
    background: #f2f2f2;
    font-family: 'Roboto', sans-serif!important;
}
.content{ 
    min-height: 80vh;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>